import Copy from "@assets/icons/copy.svg";
import { copyToClipboard } from "@helpers/utilities";
import { CSSProperties } from "react";

type Props = {
  text: string;
  startLength?: number;
  endLength?: number;
  copy?: boolean;
  link?: string;
  style?: CSSProperties;
  inline?: boolean;
};

export const EllipsisText = ({
  text,
  startLength = 4,
  endLength = 4,
  copy = false,
  link,
  inline,
  style,
}: Props) => {
  const displayText =
    text.length > startLength + endLength
      ? text.substring(0, startLength) +
        "..." +
        text.substring(text.length - endLength)
      : text;
  return (
    <div
      style={{
        display: inline ? "inline-flex" : "flex",
        alignItems: "center",
        gap: "3px",
        justifyContent: "space-between",
      }}
    >
      {link ? (
        <a
          href={link}
          target="_blank"
          style={{ textDecoration: "underline" }}
          onClick={(e) => e.stopPropagation()}
        >
          {displayText}
        </a>
      ) : (
        <div>{displayText}</div>
      )}
      {copy && text.length > 0 && (
        // <MiniButton>
        <div
          style={{ cursor: "pointer", ...style }}
          onClick={(e) => {
            e.stopPropagation();
            copyToClipboard(text);
          }}
        >
          <Copy width={16} height={16} />
        </div>
        // </MiniButton>
      )}
    </div>
  );
};
